import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';

import Modal from './Modal';

/**
 *
 * @props {boolean}visible:Loadingを表示するか？
 */
export class LoadingModal extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <Modal visible={this.props.visible}>
          <LoadingOverlay
            active
            styles={{
              wrapper: {
                width: '400px',
                height: '400px',
              },
              overlay: base => ({
                ...base,
                background: 'rgba(0, 0, 0, 0.3)',
              }),
            }}
            spinner={<FadeLoader size={100} />}
          />
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/common/LoadingModal.jsx